import { FeatureConstants } from "../../services/features-data-service/Models";

export const keys = {
    all: ["features"],
    lists: () => [
        ...keys.all,
        "list"
    ],
    list: (features: Array<FeatureConstants>) => [
        ...keys.all,
        {
            features
        }
    ]
};
